import React from 'react'
import styled from 'styled-components'
import Button from 'reactstrap/lib/Button'
import { login } from '../../../../utils/Login'

export const HeaderLoginButton = ({ ecoIdentity, children, domain }) => {
  const handleClick = () => {
    const loginLocation = ecoIdentity.login.location
    const clientId = ecoIdentity.clientId

    login({ loginLocation, clientId, returnURL: domain })
  }

  return <StyledButton onClick={handleClick}>{children}</StyledButton>
}

const StyledButton = styled(Button)`
  color: ${props => props.theme.headerLogin.loginButton.color};
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  background: ${({ theme }) => theme.headerLogin.loginButton.backgroundColor};
  border: none;
  padding-bottom: 12px;
  
  &:hover {
    color: ${({ theme }) => theme.headerLogin.loginButton.hover.color};
  }
`
